export default __webpack_public_path__ + "static/0001-f6a2ec1f7cebaa5d260a81c899418995.png";